import { connect } from 'react-redux';

import { getCustomText } from 'app/modules';
import appSelectors from 'selectors/app';
import configSelectors from 'selectors/configuration';
import uiSelectors from 'selectors/ui';
import userSelectors from 'selectors/user';
import { isMobileSdk } from 'selectors/app';
import compositionValidators from 'lib/compositionValidators';
import InputValidationComposition from 'presentation/selfService/InputValidationComposition';
import submitComposition from 'actions/messages/submitComposition';
import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';
import updateCustomerTypingState from 'actions/session/updateCustomerTypingState';

function setupCompositionStageAssets(stage, compositionText) {
  switch (stage) {
    case uiEnums.COMPOSITION_STAGES.EMAIL:
      return {
        error: compositionText.emailError,
        prompt: compositionText.emailPrompt,
        validate: compositionValidators.email,
      };
    case uiEnums.COMPOSITION_STAGES.NAME:
      return {
        error: compositionText.nameError,
        prompt: compositionText.namePrompt,
        validate: compositionValidators.name,
      };
    case uiEnums.COMPOSITION_STAGES.MESSAGE:
      return { error: '', prompt: compositionText.messagePrompt, validate: compositionValidators.message };

    default:
      return { error: '', prompt: compositionText.messagePrompt, validate: compositionValidators.message };
  }
}

export const mapStateToProps = (state, props) => {
  let attachments = uiSelectors.getUserComposition(state.ui).attachments;
  let attachmentsEnabled = configSelectors.getAttachmentsEnabled(state.configuration);
  let currentInput = uiSelectors.getCompositionDraft(state.ui);
  let compositionStageAssets = setupCompositionStageAssets(
    props.currentCompositionStage,
    getCustomText(state).composition
  );
  let name = userSelectors.getName(state.user);
  let email = userSelectors.getEmail(state.user);
  let canAddAttachments = !!(
    props.currentCompositionStage === uiEnums.COMPOSITION_STAGES.MESSAGE &&
    attachmentsEnabled &&
    !attachments[0]
  );

  return {
    ...props,
    attachments: attachments,
    canAddAttachments,
    compositionDraft: currentInput,
    errorMessage: compositionStageAssets.error,
    hasAuthError: appSelectors.getAuthError(state.app) != null,
    hasContent: /\S+/.test(currentInput) || (attachmentsEnabled && !!attachments[0]),
    hasServerError: appSelectors.getServerError(state.app) != null,
    prompt: compositionStageAssets.prompt,
    shouldAutoFocus: !email && !name && !isMobileSdk(state),
    validate: compositionStageAssets.validate,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onAttachmentChange: attachments => {
      dispatch(uiEvents.updateUserComposition({ attachments: attachments }));
    },
    onAttachmentError: error => {
      dispatch(uiEvents.updateAttachmentError(error));
    },
    onChange: (text, attachments) => {
      dispatch(uiEvents.updateUserComposition({ attachments: attachments, text: text }));
      dispatch(uiEvents.updateCompositionDraft(text));
    },
    onCustomerTypingStateUpdate: typingState => {
      dispatch(updateCustomerTypingState(typingState));
    },
    onSubmit: (currentCompositionStage, text, attachments) => {
      dispatch(submitComposition(currentCompositionStage, text, attachments));
      dispatch(uiEvents.updateUserComposition({ attachments: [], text: '' }));
      dispatch(uiEvents.updateCompositionDraft(''));
    },
  };
};

const InputValidationCompositionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InputValidationComposition);

export default InputValidationCompositionContainer;
